import { styled } from 'stitches.config'
import { Button } from 'components/Button'

export const CommentsRoot = styled('div', {
  width: '100%',
  maxWidth: '1400px',
  margin: 'auto',
  marginTop: '60px',
  padding: '0px 24px',

  '& .desktop-only': {
    display: 'none',
  },
  '& .mobile-only': {
    display: 'block',
  },

  '@bp3': {
    '& .desktop-only': {
      display: 'flex',
    },
    '& .mobile-only': {
      display: 'none',
    },
  },
})

export const ReviewCardWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  background: '$accent-white',
  borderRadius: '36px',
  padding: '28px',
  
  minHeight: 'none',
  width: '100%',
  maxWidth: '360px',

  '@bp3': {
    minHeight: '380px',
    maxWidth: '380px',
  }
})

export const RatingWrapper = styled('div', {
  '& > div': {
    marginLeft: 0,
    marginTop: '8px',
    marginBottom: '24px',
  },
})

export const ReviewColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '$5',
})

export const ReviewGrid = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '$5',
})

export const TagButton = styled(Button, {
  fontSize: '$body',
  height: '36px',

  variants: {
    active: {
      false: {
        backgroundColor: '$transparent',
        color: '$accent-black',
        borderStyle: 'solid',
        borderWidth: '2px',
        borderColor: '$primary-700',
        '&:hover, &:focus': {
          backgroundColor: '$primary-700',
          color: '$accent-white',
        },
      },
    }
  }
})
